module.exports = __webpack_public_path__ + "img/home2.14273960.png";